import {ActionTypes, FetchPpcConfigFulfilledPayload, PpcConfigActionTypes} from './types';
import {FailedRequestPayload} from '../types';

export const fetchPpcConfigPending = (payload: FetchPpcConfigFulfilledPayload): PpcConfigActionTypes => {
  return {
    type: ActionTypes.FETCH_PPC_CONFIG_PENDING,
    payload
  };
};

export const fetchPpcConfigFulfilled = (payload: FetchPpcConfigFulfilledPayload): PpcConfigActionTypes => {
  return {
    type: ActionTypes.FETCH_PPC_CONFIG_FULFILLED,
    payload
  };
};

export const fetchPpcConfigRejected = (payload: FailedRequestPayload): PpcConfigActionTypes => {
  return {
    type: ActionTypes.FETCH_PPC_CONFIG_REJECTED,
    payload
  };
};
